import { ClickEvent, Panel, RepeatItemDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutTrailerContinuityWarnings } from "./autogen/AutogenLayoutTrailerContinuityWarnings";
import { RepeatItem } from "@mcleod/components/src/components/repeater/RepeatItem";
import { ModelRow } from "@mcleod/core";

interface TrailerContinuityWarningProps {
    tractorId: string;
    stopId: string;
    trailerId?: string;
    trailer2Id?: string;
    trailer3Id?: string;
}

export class TrailerContinuityWarnings extends AutogenLayoutTrailerContinuityWarnings {
    public selectedTrailer: string;

    repeaterTrailerWarningsOnItemDisplay(event: RepeatItemDisplayEvent) {
        const repeatItem = event.getRepeatItem();
        const modelRow = repeatItem.data;
        repeatItem.minWidth = null; // prevents item from matching widths of other repeatitems
        if (!modelRow.get("message").includes("is not available")) {
            repeatItem.visible = false;
        } else {
            const locatedDate = !modelRow.isNull("locate_date");
            const trailerLastLocation = repeatItem.findComponentById("textboxTrailerLastLocation") as Textbox ?? new Textbox();
            const lastLocateDate = repeatItem.findComponentById("textboxLastLocateDate") as Textbox ?? new Textbox();
            const lastLocateDispatcher = repeatItem.findComponentById("textboxLastLocateDispatcher") as Textbox ?? new Textbox();
            const trailerMcPosition = repeatItem.findComponentById("textboxTrailerMcPosition") as Textbox ?? new Textbox();
            trailerLastLocation.caption = locatedDate ? "Last Located Move" : "Last Delivered Location";
            lastLocateDate.visible = lastLocateDispatcher.visible = !!locatedDate;
            trailerMcPosition.visible = !modelRow.isNull("trailer_tracking_licensed");
            trailerMcPosition.text = modelRow.get("mc_position", null) ?? null;
            lastLocateDispatcher.marginTop = trailerMcPosition.visible ? 8 : 0;
            if (this.mainDataSource.rowCount == 1) {
                const selectedPanel = repeatItem.findComponentById("panelTrailerWarning") as Panel;
                this.selectTrailerWarning(selectedPanel);
            }
        }
    }

    panelTrailerWarningOnClick(event: ClickEvent) {
        this.selectTrailerWarning(event.target as Panel);
    }

    selectTrailerWarning(selectedPanel?: Panel) {
        this.repeaterTrailerWarnings.components.forEach((comp: RepeatItem) => {
            const panel = comp.getComponent(0) as Panel;
            const newSelection = panel == selectedPanel && panel.backgroundColor != "primary";
            panel.backgroundColor = newSelection ? "primary" : "transparent";
            panel.color = newSelection ? "default.reverse" : "default";
            const captionColor = newSelection ? "default.reverse" : "subtle.darker";
            panel.findComponentsByType(Textbox).forEach(tb => tb.captionProps = { color: captionColor });
            if (panel == selectedPanel) {
                this.selectedTrailer = newSelection ? comp.data.get("trailer_id") : null;
            }
        });
    }

}
